import { Injectable } from '@angular/core';
import { ApiService } from '../core/services/api.service';
import { HandleErrorService } from './handle-error.service';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class FilesManagerService {

  constructor(private serviceApi: ApiService, private handleError: HandleErrorService) {
  }

  getItems(id: number, search: string): Observable<any> {
    return this.serviceApi.getForList(`Configuration/ConfigurationBlob?page=${id}&Search=${search}`).pipe(catchError(this.handleError.catchHttpError));
  }

  getItem(Img: string): Observable<any> {
    return this.serviceApi.getForList(`Configuration/ConfigurationGetBlob?Img=${Img}`).pipe(catchError(this.handleError.catchHttpError));
  }

  create(content: { img: string, img64: string }): Observable<any> {
    Swal.fire({
      title: 'Subiendo archivo...',
      text: 'Por favor espere',
      icon: 'warning',
    }).then();
    return this.serviceApi.post(`Blob/BlobFile`, content).pipe(
      catchError(this.handleError.catchHttpError),
      tap((data: { valid: boolean, message: string }) => {
        if (data.valid) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Aceptar',
            text: data.message
          }).then();
        }
      }));
  }

  edit(content: object): Observable<any> {
    Swal.fire({
      title: 'Subiendo archivo...',
      text: 'Por favor espere',
      icon: 'warning',
    }).then();
    
    return this.serviceApi.post(`Blob/ReplaceFile`, content).pipe(
      catchError(this.handleError.catchHttpError),
      tap((data: { valid: boolean, message: string }) => {
        if (data.valid) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Aceptar',
            text: data.message
          }).then();
        }
      }));
  }

  delete(id: number, img64: string): Observable<any> {
    Swal.fire({
      title: 'Eliminando archivo...',
      text: 'Por favor espere',
      icon: 'warning',
    }).then();
    Swal.showLoading();
    return this.serviceApi.delete(`Blob/File/${id}?img64=${img64}`).pipe(catchError(this.handleError.catchHttpError));
  }
}
